import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import debounce from "lodash.debounce";

import styles from "./menu-bar.css";

// 单位MB
export const MEMORY_THRESHOLD = {
    LOW: 180,
    // 超过该内存量会崩溃
    HIGH: 200
};

function ProjectPerformance(props) {
    const [memory, setMemory] = useState(0);

    useEffect(() => {
        const onTargetsUpdate = debounce(() => {
            setMemory(estimateMemory(props.vm));
        }, 1000);
        props.vm.on("targetsUpdate", onTargetsUpdate);

        return () => {
            props.vm.removeListener("targetsUpdate", onTargetsUpdate);
        };
    }, [props.vm]);

    // 根据内存大小估计性能描述
    const expectedPerformance = useMemo(() => {
        console.log('内存占用:',memory);
        if (memory <= MEMORY_THRESHOLD.LOW) {
            return '流畅';
        }

        if (memory <= MEMORY_THRESHOLD.HIGH) {
            return '卡顿';
        }

        return '崩溃';
    }, [memory]);

    return (
        <div
            style={{
                color: memory > MEMORY_THRESHOLD.HIGH ? "red" : undefined,
            }}
            className={styles.performance}
            title="在低端设备上运行的流畅度"
        >
            预计流畅度：{expectedPerformance}({memory.toFixed(0)}M)
        </div>
    );
}

const mapStateToProps = (state) => ({
    vm: state.scratchGui.vm,
});

export default connect(mapStateToProps, {})(ProjectPerformance);

/**
 * 估计 sb3 内存占用
 * @param {VM} vm
 * @returns {number} 估计的内存占用，单位MB
 */
export function estimateMemory(vm) {
    const targets = vm.runtime.targets || [];
    const memory = targets.reduce((accumulator, target) => {
        const costumes = target.sprite.costumes || [];
        const sounds = target.sprite.sounds || [];
        const soundsSize = sounds.reduce(
            (accumulator, sound) => {
                const asset = sound.asset;
                return accumulator + (asset?.data?.size || asset?.blob?.size || 0)
            },
            0
        );
        const costumesSize = costumes.reduce(
            (accumulator, costume) =>
                // 乘以 2 是因为图片数据会保留 2 份
                accumulator + costume.size[0] * costume.size[1] * 4 * 2,
            0
        );

        return accumulator + soundsSize + costumesSize;
    }, 0);

    return memory / 1024 / 1024;
}
